import React from 'react'
import { Route, Redirect } from 'react-router-dom'
import PropTypes from 'prop-types'
import { AuthService } from '../services'
const privateRoute = ({
  component: Component,
  isAuthenticated,
  redirect: pathname,
  ...rest
}) => {
  return (
    <Route
      {...rest}
      render={(props) =>
        AuthService.isLoggedIn() === true ? (
          <Component {...rest} {...props} />
        ) : (
          //   <Redirect
          //     to={{
          //       pathname,
          //       state: { from: props.location },
          //     }}
          //   />
          <Redirect to="/login" />
        )
      }
    />
  )
}

// privateRoute.defaultProps = { redirect: '/login' }

privateRoute.propTypes = {
  isAuthenticated: PropTypes.bool.isRequired,
  component: PropTypes.func.isRequired,
  redirect: PropTypes.string,
}

export const PrivateRoute = privateRoute
